import VueRouter, {Route} from 'vue-router';

export function createRouterForComponent(element: Element, baseUri?: string): VueRouter {
    const router = new VueRouter({
        ...(baseUri === undefined ? {mode: 'abstract'} : {mode: 'history', base: baseUri}),
        linkActiveClass: 'active',
        scrollBehavior: () => ({selector: '#' + element.getAttribute('id')}),
    });

    if (baseUri === undefined) {
        router.replace('/');
    }

    router.beforeEach((to, from, next) => {
        if (!hasQueryParams(to) && hasQueryParams(from)) {
            next({
                ...to,
                query: from.query,
                name: to.name == null ? undefined : to.name,
            });
        } else {
            next();
        }
    });

    return router;
}

function hasQueryParams(route: Route) {
    return Object.keys(route.query).length > 0;
}
